<style src="./NewClient.scss" lang="scss" scoped></style>
<template>
  <section class="new-client">
    <panel-tab @change-panel="changePanelTab">
      <panel-tab-item tab-id="INSERIR" :panel-choose="panelTab.panelTabChoose">
        Inserir dados
      </panel-tab-item>
      <panel-tab-item tab-id="UPLOAD" :panel-choose="panelTab.panelTabChoose">
        Upload de arquivo
      </panel-tab-item>
    </panel-tab>

    <transition name="transition-tab-item">
      <form-data-input
        v-if="panelTab.panelTabChoose === 'INSERIR'"
        @close="closePanel" />
    </transition>

    <transition name="transition-tab-item">
      <form-file-input
        v-if="panelTab.panelTabChoose === 'UPLOAD'"
        @close="closePanel" />
    </transition>

  </section>
</template>

<script>
import { PanelTab, PanelTabItem } from '@/components/primitives'
import FormDataInput from './form-data-input/FormDataInput'
import FormFileInput from './form-file-input/FormFileInput'

export default {
  name: 'NewClient',
  components: {
    PanelTab,
    PanelTabItem,
    FormDataInput,
    FormFileInput
  },
  data () {
    return {
      panelTab: {
        panelTabChoose: 'INSERIR'
      }
    }
  },
  methods: {
    closePanel () {
      this.$parent.$emit('close', false)
    },
    changePanelTab (pPanelItemId) {
      this.panelTab.panelTabChoose = pPanelItemId
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/record/client/components/new-client/NewClient.vue